import {usePhrase} from "../../i18n";
import {useEffect, useState} from "react";
import {useLayoutContext} from "../context";
import {getCookie, setCookie} from "cookies-next";
import Script from "next/script";

export default function NewLiveChat({storeConfig, _t}) {


    let t = usePhrase(_t);

    const [chatState, setChatState] = useState(0);

    const {liveChatOpen, toggleLiveChat} = useLayoutContext();
    const [chatIsOpen, setChatIsOpen] = useState(false);

    const liveChat = storeConfig?.live_chat_config;


    useEffect(() => {
        setChatState(getCookie('web-chat-state'));
    }, []);

/*    useEffect(() => {
        if (liveChat && liveChat.enable && chatState == 1) {
            initEmbeddedMessaging();
        }
    }, [liveChat, chatState]);*/


    useEffect(() => {
        if (liveChat && liveChat.enable) {
            setChatIsOpen(liveChatOpen);
        }
    }, [liveChat, liveChatOpen]);


    useEffect(() => {
        if (liveChat && liveChat.enable) {
            setChatIsOpen(liveChatOpen);
        }
    }, [liveChat, liveChatOpen]);


    const handleSetCookie = (name, value) => {
        //setCookie(name, value, {path: '/'});
        setCookie(name, value);

    }

    function initEmbeddedMessaging() {
        try {

            if (loadChatHandler)
                loadChatHandler();

            window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
            window.embeddedservice_bootstrap.settings.language = storeConfig?.store?.locale.substr(0,2) ?? 'en'; // For example, enter 'en' or 'en-US'
            window.embeddedservice_bootstrap.init(
                '00D09000002X9Lv',
                'NoFlyStore_New_Chat',
                'https://primed.my.site.com/ESWNoFlyStoreNewChat1711117448055',
                {
                    scrt2URL: 'https://primed.my.salesforce-scrt.com'
                }
            );
        } catch (err) {
            console.error('Error loading Embedded Messaging: ', err);
        }
    }



    const launchChat = () => {
        window.embeddedservice_bootstrap.utilAPI.launchChat()
            .then(() => {
                //console.log('Chat client launched successfully');
                // Success handler used to perform actions
                // when the chat client launches successfully.
                // For example, create a method that disables the launch chat button.
                //disableLaunchChatButton();
            }).catch((e) => {
            console.error('Error launching chat client: ', e);
            // Error handler used to perform actions
            // if the chat client fails to launch.
            // For example, create a method that hides the launch chat button.
            //hideLaunchChatButton();
        }).finally(() => {
            // Finally handler used to perform any clean-up actions
            // regardless of whether the chat client launches successfully or not.
            // For example, create a method that logs the user’s attempt to chat.
            //logEndUserAttemptToChat();
        });
    }


    const loadChatHandler = () => {
        if (window.embeddedservice_bootstrap) {

              MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
              window.addEventListener("onEmbeddedMessagingReady", function (e) {
                  /*if (data.isAgentAvailable) {
                      window.embeddedservice_bootstrap.liveAgentAPI.startChat();
                  }*/

                  //console.log(e);

                  let language = storeConfig?.store?.locale.substr(0,2) ?? "en";
                  let parsedLanguage = "Inglese";

                  switch (language) {
                      case "it":
                            parsedLanguage = "Italiano";
                            break;
                        case "es":
                            parsedLanguage = "Spagnolo";
                            break;
                        case "fr":
                            parsedLanguage = "Francese";
                            break;
                        case "de":
                            parsedLanguage = "Tedesco";
                            break;
                  }



                  window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
                      // List the pre-chat field names with the value and whether
                      // it's editable in the pre-chat form.
                      "Skill_Lingua": parsedLanguage
                  });

                  //console.log(window.embeddedservice_bootstrap);


                  //window.embeddedservice_bootstrap.utilAPI.hideChatButton();



              });


            window.addEventListener("onEmbeddedMessagingConversationCreated", function (data) {
                handleSetCookie('web-chat-state', 1);
            });

            /*            window.addEventListener("onChatConferenceEnded", function (data) {
                            handleSetCookie('web-chat-state', 0);
                        });*/

            window.addEventListener("onEmbeddedMessagingConversationClosed", function (event) {
                handleSetCookie('web-chat-state', 0);

            });

            /*            window.addEventListener("onChatEndedByAgent", function (data) {
                            handleSetCookie('web-chat-state', 0);

                        });*/


            /*
                        embedded_svc.addEventHandler("onChasitorMessage", function(data) {
                            loadObs();
                        });

                        embedded_svc.addEventHandler("onAgentMessage", function(data) {
                            loadObs();
                        });

                        embedded_svc.addEventHandler("onAgentJoinedConference", function (data) {
                            loadObs();
                        });*/
        } else {
            console.log('embedded_svc not loaded');
        }
    }


    if (!liveChat || !liveChat.enable)
        return <></>;


    return <>
        <Script
            src={"https://primed.my.site.com/ESWNoFlyStoreNewChat1711117448055/assets/js/bootstrap.min.js"}
            onLoad={initEmbeddedMessaging}
        />
        <div id="nf-chat-widget" className={chatIsOpen ? 'open' : ''}>
            <button aria-label={t('Open live chat')} title={t('Open live chat')} id="chat-widget-button"
                    onClick={() => toggleLiveChat()}>
                <div className="icon-root">
                    <svg viewBox="0 0 400 400">
                        <path
                            d="M187.991 141.159c11.675.152 23.046 5.307 31.082 13.343 8.036 8.339 12.888 19.256 12.888 31.234v62.772c0 11.978-4.852 23.198-13.191 31.234-8.036 8.036-19.408 13.04-31.386 13.04h-60.497l-39.725 45.789c-1.517 1.668-3.673 2.881-6.52 2.881-4.094-.151-6.672-3.032-7.126-7.126l.151-41.544c-11.675-.152-22.895-5.156-30.931-13.495C34.7 271.251 30 260.183 30 248.205v-62.621c0-11.978 4.852-23.046 13.191-31.385 8.036-8.036 19.407-13.04 31.386-13.04h113.414zm-19.952-15v-.395c0-11.978 4.852-22.895 12.888-31.234 8.036-8.036 19.408-13.191 31.082-13.343h113.414c11.978 0 23.35 5.004 31.386 13.04 8.339 8.339 13.191 19.408 13.191 31.386v62.62c0 11.978-4.7 23.046-12.736 31.082-8.036 8.34-19.256 13.343-30.931 13.495l.151 41.544c-.454 4.094-3.032 6.975-7.126 7.127-2.847 0-5.003-1.213-6.52-2.881l-39.725-45.79h-26.115c.025-15.816.012-31.633-.038-47.449-.124-13.135-4.696-25.917-12.683-36.188-1.747-2.247-4.048-4.721-4.5-5.181-10.838-11.039-25.785-17.469-41.219-17.826a66.33 66.33 0 01-.446-.007h-20.073z"></path>
                    </svg>
                    <svg className="close-icon" viewBox="0 0 24 24">
                        <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                    </svg>
                </div>

                {/* <span>{t('Chat with us')}</span>*/}

            </button>
            {chatIsOpen && <ul className="nf-chat-action-list">

                {liveChat.whatsapp && <>
                    <li><a aria-label={t('Whatsapp')} title={t('Whatsapp')} href={`https://wa.me/${liveChat.whatsapp}`}
                           target="_blank" rel="noreferrer">

                        <svg viewBox="0 0 24 24">
                            <g fill="none" fillRule="evenodd">
                                <path fill="#FFF" d="M3.52 4.51H19.52V19.509999999999998H3.52z"></path>
                                <path
                                    fill="#25D366"
                                    d="M12 0A12 12 0 110 12 12 12 0 0112 0zm5.05 6.91a7.11 7.11 0 00-11.16 8.58l-1 3.68 3.76-1a7.15 7.15 0 003.39.87 7.11 7.11 0 005-12.13zm-5 10.93A5.87 5.87 0 019 17l-.22-.12-2.23.58.6-2.18-.14-.22a5.89 5.89 0 015-9 5.91 5.91 0 015.9 5.9 5.91 5.91 0 01-5.86 5.89zm3.23-4.42c-.17-.09-1-.52-1.21-.58s-.28-.09-.4.09-.46.57-.56.69-.21.14-.38 0a5 5 0 01-1.43-.88 5.44 5.44 0 01-1-1.23.26.26 0 01.08-.36c.08-.08.18-.21.27-.32a1.38 1.38 0 00.17-.29.34.34 0 000-.31c-.05-.09-.4-1-.55-1.32s-.29-.3-.4-.3h-.34a.63.63 0 00-.47.22 2 2 0 00-.62 1.48 3.45 3.45 0 00.72 1.84 7.91 7.91 0 003 2.68c.43.18.76.29 1 .37a2.33 2.33 0 001.12.07 1.85 1.85 0 001.2-.84 1.42 1.42 0 00.1-.85c0-.02-.12-.07-.3-.15z"
                                ></path>
                            </g>
                        </svg>

                    </a>
                        <div className="nf-chat-tooltip"><span>WhatsApp</span></div>

                    </li>
                </>}

                {liveChat.instagram && <>
                    <li><a aria-label={t('Instagram')} title={t('Instagram')} href={`${liveChat.instagram}`}
                           target="_blank" rel="noreferrer">


                        <svg viewBox="25 25 350 350">
                            <circle cx="200" cy="200" r="175" fill="#fbeaf5"></circle>
                            <path
                                fill="#cd3292"
                                d="M200 25c96.585 0 175 78.415 175 175s-78.415 175-175 175S25 296.585 25 200 103.415 25 200 25zm0 74.504c-27.293 0-30.715.116-41.434.605-10.697.488-18.002 2.187-24.395 4.671-6.609 2.568-12.213 6.005-17.8 11.592-5.587 5.586-9.023 11.191-11.591 17.799-2.485 6.393-4.183 13.698-4.672 24.395-.489 10.719-.604 14.141-.604 41.434s.115 30.715.604 41.434c.489 10.697 2.187 18.002 4.672 24.395 2.568 6.608 6.004 12.213 11.591 17.8 5.587 5.587 11.191 9.023 17.8 11.591 6.393 2.484 13.698 4.183 24.395 4.671 10.719.489 14.141.605 41.434.605s30.715-.116 41.434-.605c10.697-.488 18.002-2.187 24.395-4.671 6.608-2.568 12.213-6.004 17.8-11.591 5.587-5.587 9.023-11.192 11.591-17.8 2.484-6.393 4.183-13.698 4.671-24.395.489-10.719.605-14.141.605-41.434s-.116-30.715-.605-41.434c-.488-10.697-2.187-18.002-4.671-24.395-2.568-6.608-6.004-12.213-11.591-17.799-5.587-5.587-11.192-9.024-17.8-11.592-6.393-2.484-13.698-4.183-24.395-4.671-10.719-.489-14.141-.605-41.434-.605zm0 18.108c26.834 0 30.012.102 40.609.585 9.798.448 15.119 2.085 18.661 3.461 4.691 1.823 8.038 4.001 11.555 7.517 3.517 3.517 5.694 6.865 7.517 11.555 1.377 3.542 3.014 8.863 3.461 18.661.483 10.597.586 13.775.586 40.609 0 26.834-.103 30.012-.586 40.609-.447 9.798-2.084 15.119-3.461 18.661-1.823 4.691-4 8.038-7.517 11.555-3.517 3.517-6.864 5.694-11.555 7.517-3.542 1.377-8.863 3.014-18.661 3.461-10.595.483-13.773.586-40.609.586-26.836 0-30.013-.103-40.609-.586-9.798-.447-15.119-2.084-18.661-3.461-4.691-1.823-8.038-4-11.555-7.517-3.517-3.517-5.695-6.864-7.517-11.555-1.377-3.542-3.014-8.863-3.461-18.661-.484-10.597-.586-13.775-.586-40.609 0-26.834.102-30.012.586-40.609.447-9.798 2.084-15.119 3.461-18.661 1.822-4.69 4-8.038 7.517-11.555 3.517-3.516 6.864-5.694 11.555-7.517 3.542-1.376 8.863-3.013 18.661-3.461 10.597-.483 13.775-.585 40.609-.585zm0 30.782c-28.501 0-51.606 23.105-51.606 51.606s23.105 51.606 51.606 51.606 51.606-23.105 51.606-51.606-23.105-51.606-51.606-51.606zm0 85.105c-18.501 0-33.499-14.998-33.499-33.499 0-18.501 14.998-33.499 33.499-33.499 18.501 0 33.499 14.998 33.499 33.499 0 18.501-14.998 33.499-33.499 33.499zm65.705-87.144c0 6.66-5.4 12.059-12.06 12.059s-12.059-5.399-12.059-12.059c0-6.66 5.399-12.059 12.059-12.059 6.66 0 12.06 5.399 12.06 12.059z"
                            ></path>
                        </svg>
                    </a>
                        <div className="nf-chat-tooltip"><span>Instagram</span></div>

                    </li>
                </>}

                {liveChat.telegram && <>
                    <li><a aria-label={t('Telegram')} title={t('Telegram')} href={`${liveChat.telegram}`}
                           target="_blank" rel="noreferrer">

                        <svg viewBox="0 0 24 24">
                            <g fill="none" fillRule="evenodd">
                                <path fill="#FFF" d="M4.5 5.5H18.5V18.5H4.5z"></path>
                                <path
                                    fill="#08C"
                                    d="M12 0A12 12 0 110 12 12 12 0 0112 0zM8 13.24l-2.82-.92a.64.64 0 01-.4-.8.74.74 0 01.22-.37c.7-.46 10.94-4.15 12.11-4.57a1.25 1.25 0 01.7 0 .54.54 0 01.35.37 1.17 1.17 0 010 .35.81.81 0 010 .16.45.45 0 010 .11C18.11 8.67 16.12 16.7 16 17a.93.93 0 01-.83.71 1.07 1.07 0 01-.74-.3c-.43-.37-1.41-1.07-2.36-1.72-.33.28-.84.73-1.36 1.25a1.35 1.35 0 01-.79.48.41.41 0 01-.19 0h-.05a1.13 1.13 0 01-.38-.46zm2.46 1.36a.15.15 0 00-.13 0 .12.12 0 00-.08.11c0 .42-.12 1.31-.17 1.81a.12.12 0 00.08.13.12.12 0 00.15 0c.35-.31.94-.86 1.2-1.1a.13.13 0 000-.11.13.13 0 00-.06-.1zm-.68-.71a.5.5 0 01.1-.24s2.28-2.05 3.65-3.33a.1.1 0 00-.13-.16c-1.29.77-2.95 1.84-4.55 2.84a.48.48 0 00-.19.57l.67 1.86a.15.15 0 00.15.09.15.15 0 00.12-.13l.13-1.47z"
                                ></path>
                            </g>
                        </svg>
                    </a>
                        <div className="nf-chat-tooltip"><span>Telegram</span></div>


                    </li>
                </>}

                {liveChat.fb_messenger && <>

                    <li><a aria-label={t('Messenger')} title={t('Messenger')} href={`${liveChat.fb_messenger}`}
                           target="_blank" rel="noreferrer">

                        <svg viewBox="0 0 1024 1024">
                            <defs>
                                <radialGradient
                                    id="radialGradient-1"
                                    cx="19.247%"
                                    cy="99.465%"
                                    r="108.96%"
                                    fx="19.247%"
                                    fy="99.465%"
                                >
                                    <stop offset="0%" stopColor="#09F"></stop>
                                    <stop offset="60.975%" stopColor="#A033FF"></stop>
                                    <stop offset="93.482%" stopColor="#FF5280"></stop>
                                    <stop offset="100%" stopColor="#FF7061"></stop>
                                </radialGradient>
                            </defs>
                            <g stroke="null">
                                <path
                                    fill="url(#radialGradient-1)"
                                    d="M511.494 2.702c-287.05 0-509.559 210.265-509.559 494.272 0 148.555 60.882 276.923 160.03 365.588 8.323 7.45 13.348 17.886 13.689 29.056l2.775 90.64c.887 28.912 30.75 47.725 57.207 36.046l101.14-44.648a40.676 40.676 0 0127.216-1.997c46.477 12.78 95.943 19.587 147.502 19.587 287.05 0 509.559-210.264 509.559-494.272 0-284.007-222.51-494.272-509.559-494.272z"
                                    style={{zIndex: "999"}}
                                ></path>
                                <path
                                    fill="#FFF"
                                    d="M205.506 641.522l149.683-237.475c23.81-37.779 74.796-47.185 110.521-20.392l119.05 89.288c10.923 8.193 25.952 8.15 36.83-.105l160.782-122.024c21.46-16.286 49.473 9.396 35.112 32.186L667.801 620.477c-23.812 37.777-74.798 47.185-110.521 20.39l-119.053-89.29c-10.922-8.191-25.952-8.147-36.828.108L240.615 673.709c-21.46 16.284-49.474-9.398-35.11-32.187z"
                                    style={{zIndex: "999"}}
                                ></path>
                            </g>
                        </svg>
                    </a>
                        <div className="nf-chat-tooltip"><span>Facebook</span></div>

                    </li>
                </>}


                <li onClick={(e) => launchChat()}>
                    <a aria-label={t('Talk with us')} title={t('Talk with us')} href={'#'}>
                        <svg
                            fillRule="evenodd"
                            strokeLinejoin="round"
                            strokeMiterlimit="2"

                            clipRule="evenodd"
                            viewBox="0 0 1459 1459"
                        >
                            <circle cx="729.167" cy="729.167" r="729.167" fill="#36a1e0"></circle>
                            <path
                                fill="#FFF"
                                d="M469.151 1100.21c-116.747-82.002-193.109-217.678-193.109-371.048 0-250.087 203.038-453.125 453.125-453.125 250.086 0 453.125 203.038 453.125 453.125 0 250.086-203.039 453.125-453.125 453.125-14.498 0-28.838-.683-42.989-2.018-42.34 51.682-106.649 84.684-178.606 84.684-48.115 0-92.81-14.755-129.804-39.984 43.299-29.528 76.049-73.403 91.383-124.759z"
                            ></path>
                            <circle cx="520.833" cy="729.167" r="72.917" fill="#36a1e0"></circle>
                            <circle cx="729.167" cy="729.167" r="72.917" fill="#36a1e0"></circle>
                            <circle cx="937.5" cy="729.167" r="72.917" fill="#36a1e0"></circle>
                        </svg>
                    </a>

                    <div className="nf-chat-tooltip"><span>{t('Talk with us')}</span></div>
                </li>


            </ul>}
        </div>
    </>;


}